import { createContext, useContext } from 'react'
import type { useReminders } from './hooks/use-reminders'

export type RemindersDataValue = ReturnType<typeof useReminders>

/**
 * Leaf module on purpose: it must import nothing at runtime (types only), so no
 * hot update can ever re-execute it. `createContext` at module scope means the
 * context's identity IS the module instance — if HMR re-ran this file while
 * mounted consumers held the old instance, every `useRemindersData` would throw
 * "must be used within a RemindersDataProvider" and the overlay error boundary
 * would tear the panel down. The provider component lives in
 * `reminders-data-provider.tsx` so Fast Refresh can hot-swap it freely.
 */
export const RemindersDataContext = createContext<RemindersDataValue | null>(null)

export function useRemindersData(): RemindersDataValue {
  const ctx = useContext(RemindersDataContext)
  if (!ctx) {
    throw new Error('useRemindersData must be used within a RemindersDataProvider')
  }
  return ctx
}
